<template>
  <div id="jumbotron">
    <b-jumbotron>
      <template v-slot:header>
        <img fluid alt="LogCrow logo" style="max-width:100px" src="../assets/wing_icon_256px.png">
        <h4>Search log causes and actions...</h4>
      </template>
      <ais-powered-by />
      <hr class="my-4">
      <SearchBox />
    </b-jumbotron>
  </div>
</template>

<script>
import SearchBox from './SearchBox.vue'

export default {
  name: 'LogCrowJumbotron',
  components: {
    SearchBox
  },
  props: {}
}
</script>

<style>
#jumbotron {
  margin-bottom: 0px
}
</style>
